import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { GridApi } from 'ag-grid-community';
import { UmSummaryService } from 'src/app/services/um/um-summary.service';
import { MessageBoxComponent } from 'src/app/common/message-box/message-box.component';
import { Subject } from 'rxjs';
import { UmDepartmentViewModalComponent } from './um-department-view-modal/um-department-view-modal.component';
import { DeleteBoxComponent } from 'src/app/common/delete-box/delete-box.component';
import { UntypedFormGroup, UntypedFormControl } from '@angular/forms';
import { Department } from 'src/app/models/common';
import { AdministrationSummaryService } from 'src/app/services/administration/administration-summary.service';
import { CommonService } from 'src/app/services/common.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-um-department',
  templateUrl: './um-department.component.html',
  styleUrls: ['./um-department.component.scss']
})
export class UmDepartmentComponent implements OnInit {

  columnDefs;
  collapesedOrNot: boolean;
  operations;
  tempoperation;
  gridApi: GridApi;
  selectedRow;
  rowData:any=[];
  action: Subject<any> = new Subject();
  advanceSearch;
  isSettings:boolean=false;
  deptForm: UntypedFormGroup;
   departments: any[] = [];
   content:any;
   StatusList:any[]=[];
  constructor(
    private router: Router,
    public route: ActivatedRoute,
    private summaryService: UmSummaryService,
    private modalService: NgbModal,
    private DService: AdministrationSummaryService,
    private commonService: CommonService,
  ) {
  }

  ngOnInit() {
    this.collapesedOrNot = false;

    this.StatusList.push({label:"All",value:"", checked: true});
    this.StatusList.push({label:"Active",value:"1"});
    this.StatusList.push({label:"Inactive",value:"0"});

    this.deptForm = new UntypedFormGroup({
      CODE: new UntypedFormControl(""),
      NAME: new UntypedFormControl(""),
      RECORD_STATE:new UntypedFormControl(""),
      PARENT_ID:new UntypedFormControl("")

    });
    this.departments = [];
   
     this.columnDefs= [
      {
        "headerName": "Departments",
        "field": "NAME"           
      },
      {
        "headerName": "Associated Department",
        "field": "PARENTNAME"
      },
      {
        "headerName": "Status",
        "field": "RecordStatus"
      },
    ],
    
    this.tempoperation = [ ];
    if(this.commonService.getScreenPermission("102","E")){
      this.isSettings=true;
    this.tempoperation.push({
      "name": "Edit",
        "id": "edit"
    });
  }
  if(this.commonService.getScreenPermission("102","D")){
    this.isSettings=true;
    this.tempoperation.push({
      "name": "Delete",
        "id": "delete"
    });
  }
  if(this.commonService.getScreenPermission("102","N")){
    this.tempoperation.push({
      "name": "Add Department",
        "id": "add"
    });
  }
    this.operations=this.tempoperation.map(operation => {
    return (operation && (operation.id === 'add' || operation.id === 'view_modal')) ? { name: operation.name, callback: this[operation.id], self: this, disabled: 'false' } : { name: operation.name, callback: this[operation.id], self: this }
     });
  this.setSummary("");
  }

  onSetGridApi(gridApi) {
    this.gridApi = gridApi;
  }

  onCallbackOperation(opr) {
    opr.callback();
  }

  onSelectionChanged(event) {
    this.selectedRow = this.gridApi.getSelectedRows() ? this.gridApi.getSelectedRows()[0] : null;
  }

  onRowDoubleClicked(RecordData: any) {
   const ModelRef= this.modalService.open(UmDepartmentViewModalComponent, {
    backdrop: false,
      keyboard: false,
      windowClass: 'modal-llg right modal-right',
      animation: true
    });
    ModelRef.componentInstance.Content={
      heading: 'View',
      content: { id: RecordData.data['ID'] }
    }
  }

  add() {
    let modalRef = this['self'].modalService.open(UmDepartmentViewModalComponent, {
      backdrop: false,
      keyboard: false,
      windowClass: 'modal-md right modal-right',
      animation:true
    });
    modalRef.componentInstance.Content={
      heading: 'Add',
      content: null
    }
    modalRef.result.then(result=>{
      this['self'].setSummary("");  
    })    
  }

  edit(RcordData:any) {
    let modalRef = this['self'].modalService.open(UmDepartmentViewModalComponent, {
      backdrop: false,
      keyboard: false,
      windowClass: 'modal-md right modal-right',
      animation: true
    });
    modalRef.componentInstance.Content={
      heading: 'Edit',
      content: { id: RcordData['ID'],
                AssociatedId:RcordData['PARENT_ID'] }
    }
    modalRef.result.then(result=>{
      this['self'].setSummary("");
    })
  }

  delete(RcordData:any) {
      const id = RcordData['ID'];
      const dname=RcordData['NAME'];
      let msg="";
    const modalRef = this['self'].modalService.open(DeleteBoxComponent,{backdrop: false})
        modalRef.componentInstance.Content={heading: 'Delete', custommessage: 'Are you sure you want to delete the Department '+ "'" +dname + "'" +' ?',ProceedButtonName:"Delete", TerminateButtonName:"Cancel"}
        modalRef.result.then(result => {
        if(result=="okclick")
        {
          this['self'].summaryService.deleteDeptSummary(id).subscribe(result => {
            if (result.Status === 0) {             
              this['self'].commonService.SuccessBanner(result.Message);
              this['self'].setSummary("");
            }
            else {
              this['self'].commonService.ValidationBanner(result.Message);
            }
          });
        }
      }); 
  }
  getDepartments(): void {
    this.DService.getDepartments('api/department/getdepartments/-1/' + '-1').subscribe(summary => {
        this.departments = summary["advanceSearch"];
        this.departments= [{label:"Select",value:"", checked: true}].concat(this.departments);
    });
  }

  setSummary(filter: string) {
    let strfilter = "-1";
    if (filter !== "")
      strfilter = filter;
    this.SearchClear();
    this.summaryService.getDeptSummary(strfilter,strfilter).subscribe(summary => {
      this.rowData = summary.deptist;
    });
    this.getDepartments(); 
  }

  setSearchSummary(formData) {
    this.summaryService.getDeptSearchSummary(formData).subscribe(summary => {
      this.rowData = summary;
    });
  }


  //// Advace search Functions
  SearchClear() {
    this.deptForm.reset();
  }

  AdvanceSearch() {
    var formData = this.deptForm.value;
      this.setSearchSummary(formData);
    }
  }
